<template>
    <breeze-authenticated-layout :pages="pages">
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Administrative
            </h2>
        </template>

        <breeze-page :submenus="subMenus">
            <slot></slot>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezePage from '@/Components/Page'

export default {
    components: {
        BreezeAuthenticatedLayout,
        BreezePage
    },
    props:{
        pages:Object,
    },
    data() {
        return {
            subMenus: [
                {
                    'title': 'Branches',
                    'active': route().current('administrative.branch.*'),
                    'route': 'administrative.branch.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Branch' || permission.name === 'Edit Branch' || permission.name === 'View Branch')
                },
                {
                    'title': 'Users',
                    'active': route().current('administrative.user.*'),
                    'route': 'administrative.user.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create User' || permission.name === 'Edit User' || permission.name === 'View User')
                },
                {
                    'title': 'Faculties',
                    'active': route().current('administrative.faculty.*'),
                    'route': 'administrative.faculty.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Faculty' || permission.name === 'Edit Faculty' || permission.name === 'View Faculty')
                },
                {
                    'title': 'Staff',
                    'active': route().current('administrative.staff.*'),
                    'route': 'administrative.staff.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Create Staff' ||
                        permission.name === 'Edit Staff' ||
                        permission.name === 'View Staff'
                    )
                }
            ]
        }
    },
}
</script>
